export default __webpack_public_path__ + "static/media/acc5.eec67d49.jpg";